import { isSelectionMoveKey } from '@/editor/core/selection-drag'

// 适配旧 Avue 的 document.onkeydown：普通输入不能变成画布拖拽结束事件。
export function installDraggableKeyboardGuard (Vue) {
  if (Vue.__draggableKeyboardGuard) return
  Vue.__draggableKeyboardGuard = true
  Vue.mixin({
    beforeCreate () {
      if (this.$options.name !== 'avue-draggable' && this.$options._componentTag !== 'avue-draggable') return
      const original = this.$options.methods && this.$options.methods.handleKeydown
      if (typeof original !== 'function') return
      this.$options.methods = { ...this.$options.methods, handleKeydown (...args) {
        original.apply(this, args)
        const handler = document.onkeydown
        const guarded = event => {
          if (this._isDestroyed || !this.active || this.disabled || !isSelectionMoveKey(event)) return
          event.preventDefault()
          return handler.call(document, event)
        }
        this._canvasKeyHandler = guarded
        document.onkeydown = guarded
      } }
    },
    beforeDestroy () {
      if (this._canvasKeyHandler && document.onkeydown === this._canvasKeyHandler) document.onkeydown = this.keydown || null
    }
  })
}
